import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { Crown, ImageIcon } from "lucide-react";
import { makeApi } from "@/lib/api";
import { useT } from "@/i18n";

export default function UsageBadge() {
  const { lang } = useT();
  const { getToken } = useAuth();
  const [u, setU] = useState(null);
  const load = useCallback(() => makeApi(getToken).get("/ailab/usage").then((r) => setU(r.data)).catch(() => {}), [getToken]);
  useEffect(() => {
    load();
    window.addEventListener("ailab-usage", load);
    return () => window.removeEventListener("ailab-usage", load);
  }, [load]);
  if (!u) return null;
  if (u.limit === null) {
    return <span className="inline-flex items-center gap-1 bg-yellow-300 rounded-full px-3 py-1 text-sm font-bold text-blue-950" data-testid="ai-usage-unlimited"><Crown className="w-4 h-4" /> {lang === "es" ? "Imágenes ilimitadas" : "Unlimited images"}</span>;
  }
  const left = Math.max(0, u.limit - u.used);
  return (
    <span className="inline-flex flex-wrap items-center gap-2 bg-white rounded-full px-3 py-1 text-sm font-bold text-blue-950 shadow" data-testid="ai-usage-free">
      <ImageIcon className="w-4 h-4 text-violet-600" />
      {lang === "es" ? `Te quedan ${left} de ${u.limit} imágenes hoy` : `${left} of ${u.limit} images left today`}
      {left === 0 && <Link to="/parents" className="text-blue-700 underline" data-testid="ai-usage-upgrade">{lang === "es" ? "Plan Familia" : "Family Plan"}</Link>}
    </span>
  );
}
